<template>
  <q-tab-pane name="expenses" class="no-padding">
    <div class="layout-padding">
      <div v-if="hasExpenses">
        <div class="row gutter-sm q-mt-sm">
          <expense-list :expenses="expenses" />
        </div>
      </div>

      <template v-else>
        <div class="row justify-center items-center col-grow q-pt-lg">
          <div class="text-center">
            <img src="~assets/emptystates/expenses_empty.svg" width="40%"/>

            <h6 class="q-my-md text-faded">{{ $t('no_expenses') }}</h6>
          </div>
        </div>
      </template>
    </div>
  </q-tab-pane>
</template>

<script>
  import ExpenseList from 'components/Expenses/ExpenseList'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      project: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters(['activeTeam']),

      expenses () {
        return this.project.expenses ? this.project.expenses.data : []
      },

      hasExpenses () {
        return !!this.expenses.length
      }
    },

    components: {
      ExpenseList
    }
  }
</script>
